import Layout from '@/layout/layout'

const basicData = {
  path: '/basicData',
  component: Layout,
  redirect: 'noRedirect',
  name: '往来单位管理',
  children: [
    {
      path: 'contactUnit',
      component: () => import('@/views/basicData/contactUnit/index'),
      name: '往来单位管理',
      meta: { title: '往来单位管理', noCache: true }
    }
  ]
}

export default basicData